module.exports = __webpack_public_path__ + "img/dl2.c285770d.png";